import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createApiClient } from '../client';
import { useAuth } from '../../auth/useAuth';
import type { EntityDto } from './entities';

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
}

/**
 * Deep-copies a shared-library entity (descriptors + image references) into the caller's
 * private library. The new row keeps a link to the source via sourceEntityId.
 */
export function useImportSharedEntity() {
  const { getToken } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (sharedEntityId: string) => {
      const client = createApiClient(getToken);
      const response = await client
        .post(`api/v2/entities/shared/${sharedEntityId}/import`)
        .json<ApiEnvelope<EntityDto>>();
      return response.data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['entities'] });
    },
  });
}
